import React from 'react';
import { X } from 'lucide-react';
import FilterToggle from './FilterToggle';

const Header = ({
  filterState,
  setFilterState,
  downloadData,
  triggerFileUpload,
  copyIndentedData,
  clearAllData,
  fileInputRef,
  handleFileUpload,
  logo
}) => {
  return (
    <header className="bg-emerald-400 text-white p-4 flex items-center min-w-[1000px]">
      <div className="flex items-center min-w-[200px]">
        <img src={logo} alt="Logo" className="h-8 mr-4 opacity-85" />
      </div>
      <div className="flex-1 flex justify-center min-w-[400px]">
        <h1 className="text-lg md:text-xl font-bold whitespace-nowrap">WWSC Planning-Brainstormer App</h1>
      </div>
      <div className="flex items-center gap-2 min-w-[400px] justify-end">
        <FilterToggle filterState={filterState} setFilterState={setFilterState} />
        
        <button
          className="bg-white text-emerald-400 rounded px-2 py-1 hover:bg-gray-100 cursor-pointer whitespace-nowrap text-sm md:text-base"
          onClick={downloadData}
        >
          Download
        </button>
        
        <button
          className="bg-white text-emerald-400 rounded px-2 py-1 hover:bg-gray-100 cursor-pointer whitespace-nowrap text-sm md:text-base"
          onClick={triggerFileUpload}
        >
          Upload
        </button>
        
        <input
          type="file"
          ref={fileInputRef}
          style={{ display: 'none' }}
          accept=".json"
          onChange={handleFileUpload}
        />
        
        <button
          className="bg-white text-emerald-400 rounded px-2 py-1 hover:bg-gray-100 cursor-pointer whitespace-nowrap text-sm md:text-base"
          onClick={copyIndentedData}
        >
          Copy Data
        </button>
        
        <button
          className="bg-white text-emerald-400 rounded-full p-1 hover:bg-gray-100 cursor-pointer ml-1"
          onClick={clearAllData}
          title="Clear all data"
        >
          <X size={20} />
        </button>
      </div>
    </header>
  );
};

export default Header; 